module.exports = __webpack_public_path__ + "static/media/old-login-bg.4c385210.jpg";